import { CreateVoucherPayloadData, VoucherInboxState, VoucherOrigin } from '../types'

export const getDraftVoucherData = (file: File): CreateVoucherPayloadData => ({
  origin: VoucherOrigin.WEB_APP,
  inboxState: VoucherInboxState.RECEIVED,
  files: [file],
})
